<template>
    <v-layout
        row
        wrap
    >
        <!-- Reject -->
        <v-flex>
            <!-- Reject Button -->
            <v-btn
                class="my-0"
                color="error"
                block
                @click.stop="rejectDialog = true"
            >
                <v-icon
                    left
                    size="20"
                >
                    fa-times
                </v-icon>
                Reject
            </v-btn>
            <!-- Reject Dialog -->
            <v-dialog
                v-model="rejectDialog"
                max-width="600"
            >
                <v-card>
                    <v-card-title>
                        <h3 class="headline">
                            Reject Return
                        </h3>
                    </v-card-title>
                    <v-card-text>
                        <p>Are you sure you want to reject this return? Include a reason for the rejection.</p>
                        <v-form
                            ref="rejectForm"
                            @submit.prevent="onReject"
                        >
                            <v-textarea
                                label="Message"
                                v-model="rejectForm.message"
                                :rules="[rules.required]"
                            />
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer />
                        <v-btn
                            flat
                            @click="rejectDialog = false"
                            :disabled="isSubmitting"
                        >
                            Cancel
                        </v-btn>
                        <v-btn
                            color="primary"
                            @click="onReject"
                            :disabled="isSubmitting"
                            :loading="isSubmitting"
                        >
                            Confirm
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-flex>
        <!-- Approve -->
        <v-flex>
            <!-- Approve Button -->
            <v-btn
                class="my-0"
                color="success"
                block
                @click.stop="approveDialog = true"
            >
                <v-icon
                    left
                    size="20"
                >
                    fa-check
                </v-icon>
                Approve
            </v-btn>
            <!-- Approve Dialog -->
            <v-dialog
                v-model="approveDialog"
                max-width="600"
            >
                <v-card>
                    <v-card-title>
                        <h3 class="headline">
                            Approve Return
                        </h3>
                    </v-card-title>
                    <v-card-text>
                        <p>Are you sure you want to approve this return? Once approved, the freight group department will be notified.</p>
                        <v-form
                            ref="approveForm"
                            @submit.prevent="onApprove"
                        >
                            <v-text-field
                                label="CRT #"
                                :rules="[rules.required]"
                                v-model="approveForm.crtNumber"
                            />
                            <v-textarea
                                label="Message"
                                :rules="[rules.required]"
                                v-model="approveForm.message"
                            />
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer />
                        <v-btn
                            flat
                            @click="approveDialog = false"
                            :disabled="isSubmitting"
                        >
                            Cancel
                        </v-btn>
                        <v-btn
                            color="primary"
                            @click="onApprove"
                            :disabled="isSubmitting"
                            :loading="isSubmitting"
                        >
                            Confirm
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-flex>
    </v-layout>
</template>

<script>
import axios from 'axios'
import SnackBus from '../../../utils/buses/snackBus'
import UserBus from '../../../utils/buses/userBus'
import { defaultError422, requestErrorMessage } from '../../../utils/constants/errors'
import { PENDING_FREIGHT_GROUP, OPEN, statuses } from '../../../utils/constants/statuses'

export default {
    props: {
        returnId: {
            type: String,
            required: true
        }
    },
    data () {
        return {
            rejectDialog: false,
            approveDialog: false,
            approveForm: {
                crtNumber: null,
                message: null
            },
            rejectForm: {
                message: null
            },
            rules: {
                required: value => !!value || 'This field is required'
            },
            isSubmitting: false
        }
    },
    methods: {
        onApprove () {
            if (!this.$refs.approveForm.validate()) {
                SnackBus.showMessage(defaultError422, 'error')
                return
            }
            this.isSubmitting = true

            const formData = new FormData()
            formData.set('token', UserBus.token)
            formData.set('comment', this.approveForm.message)
            formData.set('crtNumber', this.approveForm.crtNumber)

            axios.post('/api/returns/' + this.returnId + '/customerservice/approve', formData)
                .then(res => {
                    // refresh data and close dialog
                    this.$emit('refresh-data', true)
                    this.approveDialog = false
                    SnackBus.showMessage('Return Approved. Status changed to ' + statuses[PENDING_FREIGHT_GROUP].text, 'success')
                })
                .catch(err => {
                    console.log('Customer Service Approve Error', err)
                    SnackBus.showMessage(requestErrorMessage, 'error')
                })
                .finally(() => {
                    this.isSubmitting = false
                })
        },
        onReject () {
            if (!this.$refs.rejectForm.validate()) {
                SnackBus.showMessage(defaultError422, 'error')
                return
            }
            this.isSubmitting = true
            const formData = new FormData()
            formData.set('token', UserBus.token)
            formData.set('comment', this.rejectForm.message)

            axios.post('/api/returns/' + this.returnId + '/customerservice/reject', formData)
                .then(res => {
                    // refresh data and close dialog
                    this.$emit('refresh-data', true)
                    this.rejectDialog = false
                    SnackBus.showMessage('Return Rejected. Status changed to ' + statuses[OPEN].text, 'success')
                })
                .catch(err => {
                    console.log('Customer Service Reject Error', err)
                    SnackBus.showMessage(requestErrorMessage, 'error')
                })
                .finally(() => {
                    this.isSubmitting = false
                })
        }
    }
}
</script>

<style>

</style>
